import { Box, Stack } from "@mui/material";

import { FileItem } from "@/common/fileItem";
import { ArrayHelper } from "@/common/helpers/array";

import AppButton from "../Button/AppButton";
import AppIcon from "../Icons/AppIcon";
import FileItemView, { FileItemViewActions } from "./FileItemView";

export interface FileUploadListProps {
  files: FileItem[];
  itemActions?: (file: FileItem) => FileItemViewActions;
  onRemoveAll?: () => void;
}

/** List of uploaded files. */

export default function FileUploadList({ files, itemActions, onRemoveAll }: FileUploadListProps) {
  const itemWidth = 100;
  const itemHeight = 60;

  return (
    <Stack
      direction='row'
      gap={1}
      sx={{ justifyContent: "space-between", alignItems: "flex-start" }}
      data-name='FileUploadList'
    >
      <Stack direction='row' gap={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
        {files?.map((file, i) => (
          <Box key={i}>
            <FileItemView
              fileItem={file}
              size={{
                width: itemWidth,
                height: itemHeight,
              }}
              actions={itemActions?.(file)}
              imageSx={{
                width: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </Stack>

      {onRemoveAll && ArrayHelper.isNotEmpty(files) && (
        <AppButton
          variant='text'
          color='text'
          startIcon={<AppIcon of='remove' />}
          onClick={onRemoveAll}
        >
          Remove all
        </AppButton>
      )}
    </Stack>
  );
}
